<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 v-if="user.role.roleName != 'SALE'">
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 v-if="user.role.roleName == 'ADMIN' || user.role.roleName == 'BRANCH_ADMIN'">
            <v-select
              :items="shopList"
              label="Choose Shop..."
              item-text="name"
              menu-props="auto"
              item-value="id"
              v-model="queryParams.shopId"
              @change="getCountersByShopId(queryParams.shopId)"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="name"
              label="Product Name"
              type="text"
              v-model="queryParams.productName"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field
              name="code"
              label="Product Code"
              type="text"
              v-model="queryParams.productCode"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-text-field name="saleNo" label="Sale No" v-model="queryParams.saleNo" type="text"></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="saleTypes"
              label="Sale Type"
              item-text="label"
              item-value="value"
              v-model="queryParams.saleType"
              v-on:change="changeSaleType"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="payTypes"
              label="Pay Type"
              item-text="label"
              item-value="value"
              v-model="queryParams.payType"
            ></v-select>
          </v-flex>
          <v-flex sm3>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
          </v-card-title>
          <v-card-text class="font-weight-bold">
            <div>
              <span>Total Return Amount:</span>
              <v-chip>
                <span>{{ totalReturnAmount | numFormat}}</span>
              </v-chip>
              <v-btn
                color="primary"
                :loading="buttonLoading"
                @click="reprintStockReturn('printStockReturn')"
              >PRINT ALL</v-btn>
              <v-btn
                :loading="buttonLoading"
                color="success"
                @click="exportAllStockReturn()"
              >EXPORT ALL</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="stockReturnReportList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            expand
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td>{{ props.item.product.name }}</td>
                <td>{{ props.item.product.code}}</td>
                <td>{{ props.item.product.color}}</td>
                <td>{{ props.item.sale.saleNo}}</td>
                <td>{{ props.item.sale.shop.name }}</td>
                <td
                  v-if="props.item.sale.customer "
                  style="text-align:center"
                >{{props.item.sale.customer.name }}</td>
                <td v-else></td>
                <td
                  v-if="props.item.sale.customer "
                  style="text-align:center"
                >{{props.item.sale.customer.code }}</td>
                <td v-else></td>
                <td>{{ props.item.sale.payType}}</td>
                <td>{{ props.item.returnQty }}</td>
                <td>{{ props.item.returnQty * props.item.unitPrice | number }}</td>
                <!--<td>
                  <v-btn color="primary" @click.stop="reprint(props.item.sale)">REPRINT</v-btn>
                </td>-->
              </tr>
            </template>
          </v-data-table>
        </v-card>
        <!-- </v-expansion-panel> -->
      </v-flex>
    </v-layout>
    <!-- <summary report> -->
    <div id="printStockReturn" style="bsale:1px solid black;width:300px;" v-show="false">
      <div style="text-align:center">
        <p style="font-size:18px;margin:1px">Stock Return</p>
      </div>
      <div style="text-align:center">
        <p
          style="font-size:15px;margin:1px"
        >From: [{{queryParams.fromDate}}] To: [{{queryParams.toDate}}]</p>
      </div>
      <div style="text-align:left">
        <p style="font-size:15px;margin:0px">Total Return Amount: {{totalReturnAmount | numFormat}}</p>
      </div>
      <br />
      <div style="padding-left:5px;padding-right:5px">
        <div style="height:10px"></div>
        <table
          style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
        >
          <thead style="border-bottom:1px solid black;border-top:1px solid black">
            <tr>
              <th style="text-align:left">Product Name</th>
              <th style="text-align:left">Product Code</th>
              <th style="text-align:left">Product Color</th>
              <th style="text-align:left">Sale No</th>
              <th style="text-align:left">Shop</th>
              <th style="text-align:left">Customer Name</th>
              <th style="text-align:left">Customer Code</th>
              <th style="text-align:left">Pay Type</th>
              <th style="text-align:left">Return Qty</th>
              <th style="text-align:left">Return Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in allStockReturnReportList" :key="index">
              <td>{{ item.product.name }}</td>
              <td>{{ item.product.code}}</td>
              <td>{{ item.product.color}}</td>
              <td>{{ item.sale.saleNo}}</td>
              <td>{{ item.sale.shop.name }}</td>
              <td v-if="item.sale.customer " style="text-align:center">{{item.sale.customer.name }}</td>
              <td v-else></td>
              <td v-if="item.sale.customer " style="text-align:center">{{item.sale.customer.code }}</td>
              <td v-else></td>
              <td>{{ item.sale.payType}}</td>
              <td>{{ item.returnQty }}</td>
              <td>{{ item.returnQty * item.unitPrice | number }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <print detail report> -->
    <div
      style="font-size: 13px!important"
      v-show="false"
      v-for="(item,index) in allStockReturnReportList"
      :key="index"
      :id="`reprintStockReturnDetail${item.sale.id}`"
      :data="sale"
    >
      <div style="bsale:1px solid black;width:300px;">
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{item.sale.shopName}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{item.sale.shop.address}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Tel: {{item.sale.shop.phoneNo}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Invoice #: {{item.sale.saleNo}}</p>
        </div>
        <div style="text-align:center">
          <p
            style="font-size:11px;margin:0px"
            id="date"
          >{{ item.sale.createdDateInMilliSeconds | format-ms-custom-date }}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;font-weight:bold;margin:0px">REPRINT</p>
        </div>
        <div style="float:left;padding-left:11px">
          <p style="font-size:11px;margin:0px" id="counter">Counter: {{item.sale.counterName}}</p>
        </div>
        <div style="float:right;padding-right:11px">
          <p style="font-size:11px;margin:0px" id="casher">Casher: {{item.sale.createdBy}}</p>
        </div>
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left">Product Name</th>
                <th style="text-align:left">Product Code</th>
                <th style="text-align:left">Product Color</th>
                <th style="text-align:left">Customer Name</th>
                <th style="text-align:left">Customer Code</th>
                <th style="text-align:left">Pay Type</th>
                <th style="text-align:left">Return Qty</th>
                <th style="text-align:left">Return Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="text-align:center">{{item.product.name}}</td>
                <td style="text-align:center">{{item.product.code}}</td>
                <td style="text-align:center">{{item.product.color}}</td>
                <td
                  v-if="item.sale.customer "
                  style="text-align:center"
                >{{item.sale.customer.name }}</td>
                <td v-else></td>
                <td
                  v-if="item.sale.customer "
                  style="text-align:center"
                >{{item.sale.customer.code }}</td>
                <td v-else></td>
                <td style="text-align:center">{{item.sale.payType }}</td>
                <td style="text-align:right">{{item.returnQty}}</td>
                <td style="text-align:right">{{ item.returnQty * item.unitPrice | number }}</td>
              </tr>
            </tbody>
          </table>
          <div style="text-align:center">
            <p style="font-size:11px;margin:0px">Thank You! Please Come Again.</p>
          </div>
          <div style="height:10px"></div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { commonService } from "../../services/common-service";
import { stockReturnReportService } from "../../services/stock-return-report-service";
import { shopService } from "../../services/shop-service";
import { Sale } from "../../models/model";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "StockReturnReportList",

  components: { Loading },
  data: () => ({
    time: false,
    fromTime: false,
    toTime: false,
    showListLoading: false,
    dialog: false,
    user: JSON.parse(localStorage.getItem("user")),
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true
      },
      {
        text: "Stock Return Report",
        disabled: true
      }
    ],
    headers: [
      { text: "Product Name ", align: "left", value: "productName" },
      { text: "Product Code ", align: "left", value: "productcode" },
      { text: "Product Color ", align: "left", value: "productcolor" },
      { text: "Sale No", value: "sale_no" },
      { text: "Shop", value: "sh.name" },
      { text: "Customer Name ", align: "left", value: "customerName" },
      { text: "Customer Code ", align: "left", value: "customerCode" },
      { text: "Pay Type ", align: "left", value: "status" },
      { text: "Return Qty", value: "qty" },
      { text: "Return Amount", value: "amount" }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "created_date",
      totalItems: 0
    },
    rowsPerPageItems2: [25, 50, 100],
    pagination2: {
      descending: false,
      page: 1,
      rowsPerPage: 50,
      totalItems: 0
    },

    shopList: [],
    counterList: [],
    stockReturnReportList: [],
    returnItemList: [],
    allStockReturnReportList: [],
    sale: new Sale(),
    totalReturnAmount: 0,
    saleNo: 0,
    totalRows: 0,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      shopId: "",
      productCode: "",
      productName: "",
      saleNo: "",
      payType: "",
      saleType: ""
    },
    clonequeryParams: new Object(),
    buttonLoading: false,
    isLoading: false,
    payTypes: [
      { label: "----All----", value: "" },
      { label: "CASH", value: "CASH" },
      { label: "CREDIT", value: "CREDIT" }
    ],
    saleTypes: [
      { label: "RETAIL", value: "RETAIL" },
      { label: "WHOLESALE", value: "WHOLESALE" }
    ],
    fullPage: true
  }),
  watch: {
    pagination: {
      handler() {
        this.getStockReturnReportList();
        this.getStockReturnSummary();
      },
      deep: true
    }
  },
  created() {
    let user = JSON.parse(localStorage.getItem("user"));
    if (user.role.roleName == "ADMIN" || user.role.roleName == "BRANCH_ADMIN" ){
      this.getAllShop();
    }
    if (user.role.roleName != "ADMIN" || user.role.roleName != "BRANCH_ADMIN") {
      this.queryParams.shopId = user.shopId;
    }
    if (user.shopId) {
      this.getCountersByShopId(user.shopId);
    }
    if (user.role.roleName == "SALE") {
      this.queryParams.userName = user.username;
    }
    this.queryParams.saleType = "RETAIL";
    this.onSearch();
    //for deep linking
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.counterId) {
      this.queryParams.productName = this.$route.query.productName;
    }
    if (this.$route.query.counterId) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.saleNo) {
      this.queryParams.saleNo = this.$route.query.saleNo;
    }
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "stock-return-report",
        query: this.queryParams
      });
      this.clonequeryParams = Object.assign({}, this.queryParams);
      this.getStockReturnReportList();
      this.getStockReturnSummary();
    },
    changeSaleType() {
      if (this.queryParams.saleType != "RETAIL") {
        this.queryParams.payType = "CREDIT";
        this.payTypes = { label: "CREDIT", value: "CREDIT" };
      } else {
        this.queryParams.payType = "";
        this.payTypes = [
          { label: "----All----", value: "" },
          { label: "CASH", value: "CASH" },
          { label: "CREDIT", value: "CREDIT" }
        ];
      }
    },
    getStockReturnReportList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      stockReturnReportService
        .getStockReturnReportList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.stockReturnReportList = res.data;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then(res => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "----All----"
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch(err => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getStockReturnSummary() {
      stockReturnReportService
        .getStockReturnSummary(this.queryParams)
        .then(res => {
          if (res.data) {
            this.totalReturnAmount = res.data.totalReturnAmount;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    reprint(sale) {
      this.isLoading = true;
      this.reprintStockReturn("reprintStockReturnDetail" + sale.id);
      this.isLoading = false;
    },
    reprintStockReturn(divName) {
      this.buttonLoading = true;
      stockReturnReportService
        .getAllStockReturnReportList(this.clonequeryParams)
        .then(res => {
          if (res.data) {
            this.allStockReturnReportList = res.data;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.buttonLoading = false;
        });
    },
    exportAllStockReturn() {
      this.buttonLoading = true;
      stockReturnReportService
        .exportStockReturnExcel(this.clonequeryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    clear() {
      this.queryParams.data = commonService.formatDate(
        new Date(),
        "YYYY-MM-DD"
      );
      this.queryParams.fromTime = "00:00";
      this.queryParams.toTime = "23:59";
    }
  }
};
</script>
